export default {
  School: 0,
  Profile: 1,
}
